export const COOKIE_BANNER_SET_ACCEPTED = 'COOKIE_BANNER_SET_ACCEPTED';
export const COOKIE_BANNER_SET_HEIGHT = 'COOKIE_BANNER_SET_HEIGHT';
